import type { AnalyticsFlightsAndAppSettings } from 'owa-analytics-types';
import { getApplicationSettings } from 'owa-application-settings';
import { isGulpOrBranching } from 'owa-config';
import { isDataWorkerPlatformEnabled } from 'owa-data-worker-check';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Make sure this isn't imported in the analytics worker
 *	> 'owa-feature-flags' import is restricted from being used. Feature flags have to be passed in the analytics worker initialization [analytics-worker-lint] */
import { isFeatureEnabled } from 'owa-feature-flags';

let flightsAndApplicationSettingsCache: AnalyticsFlightsAndAppSettings | null = null;

export function getAnalyticsFlightsAndAppSettings(): AnalyticsFlightsAndAppSettings {
    if (!flightsAndApplicationSettingsCache) {
        flightsAndApplicationSettingsCache = initializeAnalyticsFlightsAndAppSettings();
    }

    return flightsAndApplicationSettingsCache;
}

export function updateFlightsAndApplicationSettingsCache(cache: AnalyticsFlightsAndAppSettings) {
    flightsAndApplicationSettingsCache = cache;
}

function initializeAnalyticsFlightsAndAppSettings() {
    const isDevEnvironment = isGulpOrBranching();
    const analyticsApplicationSettings = getApplicationSettings('Analytics');

    const settings: AnalyticsFlightsAndAppSettings = {
        // ECS Settings
        disabledDatapoints: analyticsApplicationSettings.disabledDatapoints || [],
        throttledDatapoints: analyticsApplicationSettings.throttledDatapoints || [],
        disableIsCoreDatapoints: analyticsApplicationSettings.disableIsCoreDatapoints || [],
        enableHighCountEventThrottle: analyticsApplicationSettings.enableHighCountEventThrottle,
        highCountEventThrottleWindow: analyticsApplicationSettings.highCountEventThrottleWindow,
        highCountEventThrottleThreshold:
            analyticsApplicationSettings.highCountEventThrottleThreshold,
        capturePerfProfiles: analyticsApplicationSettings.capturePerfProfiles || [],

        // Feature Flights
        shouldCaptureAssets: isFeatureEnabled('an-log-assets'),
        skipFlightControls:
            isFeatureEnabled('ring-dogfood') || isFeatureEnabled('an-no-sample-ppe'),
        isFullVerboseLoggingEnabled: isFeatureEnabled('an-full-logging'),
        enablePrivacyGuard: isFeatureEnabled('fwk-oneDs-privacyGuard'),
        turnOffCustomData: isFeatureEnabled('fwk-turnOffCustomData'),
        devToolsEnabled: isDevEnvironment || isFeatureEnabled('fwk-devTools'),
        trackEventFrequency: isFeatureEnabled('fwk-an-trackEventFrquency'),
        isDataWorkerEnabled: isDataWorkerPlatformEnabled(),
        enableOfflineCaching: isFeatureEnabled('fwk-offline-boot'),
    };

    return settings;
}
